export default __webpack_public_path__ + "static/bezpieczenstwo-82c386e5b94548329cc6c9b40bbaa62c.png";